import { apiClient } from './client';
import { YEREL_DEMO } from '../demo/yerelDemoKipi';
import type { AynaDurumu } from '@raporgor/utils';

/**
 * Firmanın veri hattı tazeliği. Firma kimliği İSTEMEZ — sunucu onu JWT'den çözer.
 * Bir `firmId` parametresi olsaydı bir müşteri başka firmanın durumunu okurdu.
 */
export interface VeriTazeligi {
  /** Yanlışsa panel HİÇBİR ŞEY çizmez (CDC aynası yok ya da kurulum bitmemiş). */
  izleniyor: boolean;
  sonSenkronUtc: string | null;
  /** 🔴 Yaş SUNUCUDA hesaplanır — tarayıcı saati kaymışsa rozet sessizce yalan söylerdi. */
  yasSaniye: number | null;
  durum: AynaDurumu;
}

export const veriTazeligiApi = {
  get: (): Promise<VeriTazeligi> =>
    // S334 yerel demo: ayna yok, gösterge çizilmez, ağa çıkılmaz.
    YEREL_DEMO
      ? Promise.resolve({ izleniyor: false, sonSenkronUtc: null, yasSaniye: null, durum: 'hic' })
      : apiClient
      .get<VeriTazeligi>('/api/v1/veri-tazeligi')
      .then((r) => r.data),
};
